// extracted by mini-css-extract-plugin
module.exports = {"container":"_2aMmw","button":"_14360","actionsContainer":"_3IAA4","center":"_1uveU","right":"_1xkry","triangle":"_2qBW-","actionsPadding":"_26T6r"};